import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Form, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import SkipButton from "./SkipButton";
import getNextPage from "./getNextPage";
import { RouterContext } from "./Onboarding";

export default function InvoiceRecipients({
  pageLocator,
  invoiceRecipients,
  setInvoiceRecipients,
  handleDeleteRecipient,
  handleAddRecipient,
  submitForm,
  onboarding_progress,
}) {
  const route = useContext(RouterContext);

  const nextPage = getNextPage(onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);

  pageLocator();

  const [validated, setValidated] = useState(false);

  useEffect(() => {
    const form = document.getElementById("onboarding-form");
    if (invoiceRecipients.length > 0 && form.checkValidity() === true) {
      setValidated(true);
    } else {
      setValidated(false);
    }
  });

  return (
    <>
      <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
      <Row className=" pb-3 justify-content-center">
        <Col style={{ backgroundColor: "#EEEEEE" }} className=" d-flex flex-column align-items-center mb-2 pb-2 ">
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">Invoice Recipients</p>
          </div>
          <div style={{ maxWidth: "780px" }}>
            <p className=" f16 nunito-regular primary text-left">
              Here we will add emails that will receive invoices. You can add any number of emails here, and invoices will be sent to the provided
              addresses at the end of every month.
            </p>
          </div>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col style={{ maxWidth: "500px" }}>
          <Row>
            <Col className="d-flex pb-3 justify-content-center">
              <p className="visby-bold f14 light-primary">Add email</p>
            </Col>
          </Row>
          {invoiceRecipients.map((invoiceRecipient, index) => {
            return (
              <Row className="pl-3" style={{ flexWrap: "nowrap" }} key={invoiceRecipient.id ? invoiceRecipient.id : uuidv4()}>
                <Form.Control
                  size="sm"
                  placeholder=""
                  value={invoiceRecipient.email}
                  className="tableSearch mr-2 mb-2 d-inline-block"
                  style={{ maxWidth: "82%" }}
                  onChange={(e) => {
                    let newRecipients = [...invoiceRecipients];
                    newRecipients[index].email = e.target.value;
                    setInvoiceRecipients(newRecipients);
                  }}
                  pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
                  required
                />
                <button className="pr-0" type="button" onClick={() => handleDeleteRecipient(invoiceRecipient.id)}>
                  <i className="fas mb-2 fa-minus-circle"></i>
                </button>
              </Row>
            );
          })}
          <Row className="mb-5" style={{ maxWidth: "100%" }}>
            <Col>
              <Button onClick={() => handleAddRecipient()} className="mt-4 mb-2 btn-sm px-3 mr-3 text-center" variant="success">
                + Add email
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`E-mail must be entered and formatted correctly. " email@example.com "`}
              submitForm={submitForm}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
